import get from 'lodash.get';

import { emptyArray, emptyObject } from '../../default-props/empty';

export const AllInstances = (state) => get(state, 'instances', emptyObject);
const Instance = (state, { rateViewerKey }) => get(AllInstances(state), rateViewerKey, emptyObject);
export const IsLoading = (state, props) => get(Instance(state, props), 'isLoading', false);
export const Rates = (state, props) => get(Instance(state, props), 'rates', emptyArray);
export const Errors = (state, props) => get(Instance(state, props), 'errors', emptyArray);
export const SellerProviderId = (state, props) => get(Instance(state, props), 'selectedSellerProviderId');
export const Rate = (state, props) => get(Instance(state, props), 'selectedRate', undefined);
